import ApiResponse from "sr/models/ApiResponse";
import { put } from "sr/utils/axios";
import { toast } from "react-toastify";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
export const updateBasicDetails = async (putData) => {
    try {
        return await put<ApiResponse<[]>>('/job/', putData ).then((res)=> {
            if(res?.success=== true) {
                return res
            }
            else {
                if (res?.error?.message) {
                    toast.error(res.error.message)
                }
                return res
            }
        })
        }
        catch (e:any) {
            HandleApiError(e);
            return null
        }
};
